/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/editor_factory.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    editorFactoryModule
} from "../../../grids/grid_core/editor_factory/m_editor_factory";
import gridCore from "../m_core";
gridCore.registerModule("editorFactory", editorFactoryModule);
